import React from 'react'

const textToTypeMap = (text)=>({
    'pending': 'primary',
    'voting': 'kaki',
    'in development': 'white30',
    'released': 'success',
    'approved': 'success',
    'rejected': 'error'
}[text?.toLowerCase()])

const AppLabel = ({
                      type,
    text,
                      ...props})=><div
    {...props}
className={`${(props.className)} label ${type || textToTypeMap(text)}-bg`}

>
    {
        text
    }
</div>

export default AppLabel